import src from "IMAGE";
export default { src, width: 92, height: 92, blurWidth: 8, blurHeight: 8, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAATklEQVR42oWPOwoAMQhEc/0tt/RqYmFjYeEJBF1cSJokWAw8mIefQUSPmb2nVDcKMhNm3H1xdUuICFBVYOafN0FEABHvE1qhXXE9snvzA/1M2tlwlSOQAAAAAElFTkSuQmCC"};
